import {
  LIST_PRICE_REQUEST_MESSAGES,
  ListPriceRequestMessages,
} from "./list-price-request.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { MULTI_SELECT_MESSAGES, MultiSelectMessages } from "../inputs/multi-select.messages";

export type ListPriceFormMessages = MultiSelectMessages &
  ListPriceRequestMessages &
  ActionButtonMessages & {
    //Titles
    categoryTitle: string;
    photosTitle: string;
    informationGroupTitle: string;

    //Labels messages
    activeLabel: string;
    codeLabel: string;
    externalReferenceLabel: string;
    titleLabel: string;
    eanLabel: string;
    stockLabel: string;
    shortDescriptionLabel: string;
    descriptionLabel: string;
    brandLabel: string;
    ncmLabel: string;
    kitLabel: string;
    priceLabel: string;
    pickUpInStoreLabel: string;
    warrantyTimeLabel: string;
    variationsLabel: string;

    //Photos
    dropPhoto: string;

    //Options
    noProductVariationOption: string;

    //Error messages
    errorRequiredProductCode: string;
    errorRequiredProductTitle: string;
    maximumOfPhotos: string;
    characterLimitExceeded: string;
    charactersRemaining: string;
    errorRemovePhoto: string;
    unsupportedFileFormat: string;
    invalidFileName: string;
    imageDimensionsExceeded: string;

    pricingGroupTitle: string;
    promotionalPriceLabel: string;
    promotionStartLabel: string;
    promotionEndLabel: string;

    errorRequiredPromotionDates: string;
    errorPromoPriceGreaterThanZero: string;

    errorRequiredCode: string;
    errorRequiredMainPrice: string;
    errorMainPriceGreaterThanZero: string;
    errorStartPromoPriceMustBeBeforeEndPromoPrice: string;
    errorRequiredPromotionStartDate: string;
    errorEndPromoPriceMustBeAfterStartPromoPrice: string;
    errorRequiredPromotionEndDate: string;

    //tabs
    informationTab: string;
  };

export const LIST_PRICE_FORM_MESSAGES: ListPriceFormMessages = {
  //Titles
  categoryTitle: "Categorias",
  photosTitle: "Imagens do produto",
  informationGroupTitle: "Informações",

  // Labels messages
  priceLabel: "Preço",
  activeLabel: "Status",
  codeLabel: "Código",
  externalReferenceLabel: "Referência Externa",
  titleLabel: "Título",
  eanLabel: "EAN",
  stockLabel: "Estoque",
  shortDescriptionLabel: "Descrição Curta",
  descriptionLabel: "Descrição",
  brandLabel: "Marca",
  ncmLabel: "NCM",
  kitLabel: "Kit",
  pickUpInStoreLabel: "Retirar em loja",
  warrantyTimeLabel: "Tempo de garantia (meses)",
  variationsLabel: "Variação",

  //Photos
  dropPhoto: "Arraste as imagens aqui, ou clique para selecionar",

  //Options
  noProductVariationOption: "Nenhuma variação",

  // Error messages
  errorRequiredProductCode: "O código do produto é obrigatório!",
  errorRequiredProductTitle: "O título do produto é obrigatório!",
  maximumOfPhotos: "Você pode adicionar no máximo 10 fotos.",
  characterLimitExceeded: "O limite de caracteres foi excedido",
  charactersRemaining: "caracteres restantes",
  errorRemovePhoto: "Erro ao remover a imagem.",
  unsupportedFileFormat: "Formato de arquivo não suportado. Apenas JPG, JPEG e PNG são permitidos.",
  invalidFileName: "Nome de arquivo inválido. Não use espaços, traços ou caracteres especiais.",
  imageDimensionsExceeded: "As dimensões da imagem excedem o limite de 2000x2000 pixels.",

  pricingGroupTitle: "Preços",
  promotionalPriceLabel: "Preço Promocional",
  promotionStartLabel: "Início da Promoção",
  promotionEndLabel: "Fim da Promoção",

  errorRequiredPromotionDates:
    "As datas de início e fim da promoção são obrigatórias quando um preço promocional é definido.",
  errorPromoPriceGreaterThanZero:
    "O preço promocional deve ser maior que zero quando as datas de promoção estão definidas.",

  errorRequiredCode: "O código é obrigatório!",
  errorRequiredMainPrice: "O preço principal é obrigatório!",
  errorMainPriceGreaterThanZero: "O preço principal deve ser maior que zero!",
  errorStartPromoPriceMustBeBeforeEndPromoPrice:
    "A data de início da promoção deve ser anterior à data de término da promoção!",
  errorRequiredPromotionStartDate:
    "A data de início da promoção é obrigatória quando o preço promocional é informado.",
  errorEndPromoPriceMustBeAfterStartPromoPrice:
    "A data de término da promoção deve ser posterior à data de início da promoção!",
  errorRequiredPromotionEndDate: "A data de término da promoção é obrigatória!",

  //tabs
  informationTab: "Informações",

  ...ACTION_BUTTON_MESSAGES,
  ...LIST_PRICE_REQUEST_MESSAGES,
  ...MULTI_SELECT_MESSAGES,
};
